import React from 'react'
import Header from '../Header/Header'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
import QrData from '../../Components/Admin/QrData/QrData'

export default function Qr() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    <QrData />
                </div>
            </section>
        </div>
    )
}
